import React from "react";
import { pressureUlcerIntro } from "../../Util/writing";
import { getNarrowTextDivStyle } from "../../Util/util";

const PressureUlcerIntro = (props) => {
  return <div style={getNarrowTextDivStyle(props.width)}>{pressureUlcerIntro}</div>;
};
export default PressureUlcerIntro;
